/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Recording/view.blocks to change it.
import PauseAction from './PauseAction/index'
import React from 'react'
import StopAction from './StopAction/index'
import VolumeIndicator from './VolumeIndicator/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Recording({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Recording"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Recording.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<VolumeIndicator
  viewPath={`${viewPath}/VolumeIndicator`}
/>
<div
  data-testid="Recording.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PauseAction
  viewPath={`${viewPath}/PauseAction`}
/>
<StopAction
  viewPath={`${viewPath}/StopAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}